import { type JSX } from "react";
import FormInputComponent from "@via/components/inputs/form-input-component.tsx";
import { requiredValidation } from "@via/utils/form-validators.tsx";

const githubDocumentationLink =
  "https://docs.github.com/en/authentication/keeping-your-account-and-data-secure/managing-your-personal-access-tokens";

export default function CreateGithubToken({ control }): JSX.Element {
  return (
    <>
      <FormInputComponent
        control={control}
        name="name"
        label="Token Name"
        placeholder="Enter Token Name"
        validations={requiredValidation("Token Name")}
        showRequiredField
      />
      <FormInputComponent
        control={control}
        name="credentialData.username"
        label="Account Username"
        placeholder="Enter Account Username"
        validations={requiredValidation("Account Username")}
        showRequiredField
      />
      <FormInputComponent
        control={control}
        name="credentialData.email"
        label="Account Email"
        placeholder="Enter Your Account Email"
        validations={requiredValidation("Email")}
        showRequiredField
      />
      <FormInputComponent
        control={control}
        name="credentialData.token"
        label="Token"
        placeholder="Enter Your Token"
        validations={requiredValidation("Token")}
        showRequiredField
      />
      <div className="mt-3">
        <p className="text-xs text-gray-500">
          Token will be used for downloading, creating and updating
          repositories. Please follow{" "}
          <a
            className="text-blue-600"
            target="_blank"
            href={githubDocumentationLink}
            rel="noreferrer">
            this guide in GitHub to create a token.
          </a>{" "}
          While creating token, please enable repo and write:packages in the
          scope section.
        </p>
      </div>
    </>
  );
}
